/**
 * A mixin with helper functions to identify object classes.
 *
 * The backend has separate models which are often similar enough to
 * others that we will want to reuse widgets in the client to present
 * them, however there are usually still small differences in how to
 * handle them so a clear distinction is necessary. The backend marks
 * each serialized object with a 'kind' attribute that we can use here
 * to correctly identify each of them.
 *
 */

export function isTVSpotBundle(obj) {
  return obj.kind === 'tvspotbundle';
}

export function isSpot(obj) {
  return obj.kind === 'radiospot' || obj.kind === 'tvspot';
}

export function isTVSpot(obj) {
  return obj.kind === 'tvspot';
}

export function isRadioSpot(obj) {
  return obj.kind === 'radiospot';
}

export function isClosingTimeRadioSpot(obj) {
  return obj.kind === 'radiospot' && obj.closingtime;
}

export function isTicker(obj) {
  return obj.kind === 'ticker';
}

export function isUploadImage(obj) {
  return obj.kind === 'uploadimage';
}

export function isSpotEntry(obj) {
  return obj.kind.endsWith('spotentry');
}

export function isTagEntry(obj) {
  return obj.kind.endsWith('tagentry');
}

export function isRadioTagEntry(obj) {
  return obj.kind == 'radiotagentry';
}

export function isTVTagEntry(obj) {
  return obj.kind == 'tvtagentry';
}

export function isClosingTimeRadioSpotEntry(obj) {
  return obj.kind == 'closingtimeradiospotentry';
}

export function isTickerEntry(obj) {
  return obj.kind === 'tickerentry';
}

var identifiers = {
  methods: {
    isClosingTimeRadioSpot,
    isClosingTimeRadioSpotEntry,
    isRadioSpot,
    isRadioTagEntry,
    isSpot,
    isSpotEntry,
    isTagEntry,
    isTicker,
    isTickerEntry,
    isTVSpot,
    isTVSpotBundle,
    isTVTagEntry,
    isUploadImage,
  },
};

export default identifiers;



// WEBPACK FOOTER //
// ./src/mixins/identifiers.js